import React, { Fragment } from "react";

import Header from "../components/Header/Header";
import Navmenu from "../components/Navmenu/Navmenu";
import Task from "../components/Task/Task";
import Sidebar from "../components/Sidebar/Sidebar";
import Footer from "../components/Footer/Footer";
import CompHeader from "../components/Comp-Header/Comp-Header";
import CompHeaderElect from "../components/Comp-Header/Comp-Header-Elect";
import CompHeaderEle from "../components/Comp-Header/Comp-Header-Ele";

const structure = [
  {
    name: `ЭЛЕКТРОСТАТИКА`,
  },
];

const Test = () => {
  return (
    <Fragment>
      <Header />
      {/* {structure.map((item) => (
        <Navmenu item={item} />
      ))} */}
      <br /><br /><br />
      <CompHeader />
      {/* <TaskComp /> */}
      <CompHeaderElect />
      {/* <TaskCompElect /> */}
      <CompHeaderEle />
      {/* <TaskCompEle /> */}
      <Task />
      <Sidebar />
      <Footer />
    </Fragment>
  );
};

export default Test;
